import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { WeeklyTrend } from '@/services/admin/adminPrivilegedService';

interface ActivityTrendsChartProps {
  weeklyTrends?: WeeklyTrend[];
}

const ActivityTrendsChart: React.FC<ActivityTrendsChartProps> = ({ weeklyTrends }) => {
  const chartData = weeklyTrends?.slice().reverse().map(trend => ({
    week: new Date(trend.weekStart).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
    recipesCreated: trend.recipesCreated,
    mealsPlanned: trend.mealsPlanned,
    feedbackAdded: trend.feedbackAdded,
    newUsers: trend.newUsers,
    totalActivity: trend.totalActivity
  })) || [];

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-semibold">Weekly Activity Trends</CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="week" />
            <YAxis />
            <Tooltip />
            <Line type="monotone" dataKey="recipesCreated" stroke="#ea580c" strokeWidth={2} name="Recipes" />
            <Line type="monotone" dataKey="mealsPlanned" stroke="#9333ea" strokeWidth={2} name="Meals" />
            <Line type="monotone" dataKey="feedbackAdded" stroke="#2563eb" strokeWidth={2} name="Feedback" />
            <Line type="monotone" dataKey="totalActivity" stroke="#16a34a" strokeWidth={2} name="Total" />
          </LineChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};

export default ActivityTrendsChart;